import ColumnsContent from 'components/Hocs/ColumnsContent';
import ContentMain from './MyParticipation';

export default ColumnsContent(ContentMain);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/Competitions/MyParticipation/index.js